import { useMemo } from 'react';
import { Image, ImageStyle } from 'expo-image';

import { ImageProps } from './Image.types';
import useStyle from '../../hooks/useStyle';
import { getImages } from '../../assets/images/registry';

import '../../assets/images';

function CustomImage({
  name,
  source,
  placeholder,
  contentFit = 'contain',
  placeholderContentFit,
  contentPosition,
  transition,
  blurRadius,
  tintColor,
  priority,
  cachePolicy,
  responsivePolicy,
  recyclingKey,
  autoplay,
  onLoadStart,
  onLoad,
  onProgress,
  onError,
  onLoadEnd,
  onDisplay,
  focusable,
  accessible,
  accessibilityLabel,
  alt,
  enableLiveTextInteraction,
  allowDownscaling,
  decodeFormat,
  ...rest
}: ImageProps<ImageStyle>) {
  const style = useStyle<ImageStyle>(rest);
  const src = useMemo(() => {
    const images = getImages();

    if (name) {
      const [ns, img] = name.split('.');

      return images[ns as keyof RegisteredImages]?.[
        img as keyof RegisteredImages[keyof RegisteredImages]
      ];
    }

    if (typeof source === 'string') {
      return { uri: source };
    }

    return source;
  }, [name, source]);

  return (
    <Image
      style={style}
      source={src}
      placeholder={placeholder}
      contentFit={contentFit}
      placeholderContentFit={placeholderContentFit}
      contentPosition={contentPosition}
      transition={transition}
      blurRadius={blurRadius}
      tintColor={tintColor}
      priority={priority}
      cachePolicy={cachePolicy}
      responsivePolicy={responsivePolicy}
      recyclingKey={recyclingKey}
      autoplay={autoplay}
      onLoadStart={onLoadStart}
      onLoad={onLoad}
      onProgress={onProgress}
      onError={onError}
      onLoadEnd={onLoadEnd}
      onDisplay={onDisplay}
      focusable={focusable}
      accessible={accessible}
      accessibilityLabel={accessibilityLabel}
      alt={alt}
      enableLiveTextInteraction={enableLiveTextInteraction}
      allowDownscaling={allowDownscaling}
      decodeFormat={decodeFormat}
    />
  );
}

CustomImage.prefetch = Image.prefetch;

export default CustomImage;
